import React from "react";
import guidebookHomeSectionStyle from "./guidebookHomeSectionStyle";
import Container from "../../../Container/Container";
import Typography from "@mui/material/Typography";
import AreaSelection from "../../../AreaSelection/AreaSelection";

const GuidebookHomeSection = () => {
  return (
    <>
      <Container>
        <Typography variant={"h2"} sx={guidebookHomeSectionStyle.heading}>
          Welchen Ratgeber möchten Sie lesen?
        </Typography>
      </Container>
      <AreaSelection linkedCardList={"guidebook"} mobileCtaText={"ZUM RATGEBER"} />
    </>
  );
};

export default GuidebookHomeSection;
